import { toast } from "sonner";
import { TicketDetails, ticketsList } from "../types/helpDeskType";
import { ApiResponse } from "../types/responseType";
import customFetch from "../util/config/axiosConfig";
import { PaginatedResponse } from "../types/paginationType";

const helpDeskApis = {
  // GET all
  fetchTickets: async (
    params: Record<string, string>
  ): Promise<ApiResponse<PaginatedResponse<TicketDetails>>> => {
    const response = await customFetch.get<
      ApiResponse<PaginatedResponse<TicketDetails>>
    >(`/api/v1/help-desk/filter`, { params });

    return response.data;
  },

  // POST
  createTicket: async (
    payload: ticketsList
  ): Promise<ApiResponse<ticketsList> | undefined> => {
    try {
      const response = await customFetch.post<ApiResponse<null>>(
        `/api/v1/help-desk`,
        payload
      );
      toast.success(response.data.data || "Ticket Created successfully");
      return response.data.data;
    } catch (error) {
      console.error("Error creating class:", error);
      toast.error(error?.response?.data?.message || "somthing went wrong");
    }
  },

  // DELETE
  deleteTicket: async (
    ticketId: number
  ): Promise<ApiResponse<null> | undefined> => {
    try {
      const response = await customFetch.delete<ApiResponse<null>>(
        `/api/v1/help-desk/${ticketId}`
      );
      toast.success(response.data.data || "Ticket Deleted successfully");
      return response.data.data;
    } catch (error) {
      console.error(`Error deleting ticket with ID ${ticketId}:`, error);
    }
  },

  // GET BY ID
  fetchTicketsyId: async (
    ticketId: number
  ): Promise<ApiResponse<TicketDetails> | undefined> => {
    try {
      const response = await customFetch.get<ApiResponse<TicketDetails>>(
        `/api/v1/help-desk/${ticketId}`
      );

      return response.data;
    } catch (error) {
      toast.error(`Error fetching Tickets with ID ${ticketId}:`, error);
    }
  },

  // PUT
  updateClass: async (
    ticketId: number,
    payload: ticketsList,
  ): Promise<ApiResponse<ticketsList> | undefined> => {
    try {
      const response = await customFetch.put<ApiResponse<ticketsList>>(
        `/api/v1/help-desk/${ticketId}`,
        payload
      );

      return response.data;
    } catch (error) {
      console.error("Error updating class:", error);
    }
  },
};

export default helpDeskApis;
